import { gql } from "@apollo/client";

export const GET_CUIDADOS_PALIATIVOS_RI_BY_ID = gql`
query CuidadosPaliativosRIById(
    $idDatosGenerales: Int!
){
    cuidadosPaliativosRIByDatosGeneralesId(
        idDatosGenerales: $idDatosGenerales
    ){
        cuidadosPaliativosRI {
            idCuidadosPaliativosRI
            idDatosGeneralesRI
            directivasAnticipadas
            otrosEstudios
            cuidadorPrincipal
            profesionOcupacion
            pasatiempo
            religion
            medicoCabecera
            idComboRIValorECOG
            idComboRIValorTabaquismo
            antecedenteAlcoholismo
            antecedenteConsumoSustancias
            descSustancia
            tensionArterial
            temperatura
            frecRespiratoria
            frecCardiaca
            otros
            videodeglucion
            digestivo
            respiratorio
            cV
            sNC
            pielMucosasFaneras
            aduESAS
            dolor
            disnea
            nauseas
            depresion
            ansiedad
            anorexia
            bienestar
            cansancio
            insomnio
            somnolencia
            constipacion
            resultadoAduESAS
            soporteNutricional
            sondaNasogastrica
            cateter
            sondaVesical
            idComboRIValorPedEscalaDolor
            pedGMFS
            resultadoPedGMFS
            idComboRIValorPedLANSKY
            pedFPSR
            resultadoPedGustaveRoussy
            pedGustaveRoussy
            resultadoPedFLACCR
            pedFLACCR
            resultadoPedFPSR
            escalaNumericaDolor
            resultadoEscalaNumericaDolor
            viveSolo
            claudicacionFamiliar
            cuidadoresContratados
            datosSocioEcoFamiliares
            idComboRIValorTrastornoAdaptacion
            idComboRIValorCercoDeSilencio
            idComboRIValorNombraPalabraCancer
            idComboRIValorPoseeInfEnfermedad
            idComboRIValorPoseeInfPronostico
            idComboRIValorPoseeInfDiagnostica
            otrasIndicaciones
            problemaEspiritual
            problemaSocial
            problemaPsicologico
            problemaFisico
            otrosDatosInformacion
            cPMedicacionDosificacionRI {
                descripcion
            }
        }
        directivasAdjunto {
            contentType
            titulo
            archivo
            extension
        }
        estudioAdjunto {
            contentType
            titulo
            archivo
            extension
        }
        videodeglucionAdjunto {
            contentType
            titulo
            archivo
            extension
        }
    }
}`;